import config from "appConfig";
import { Slide } from "@jelly/lesson";

const principle: Slide = {
  titleHtml: `<div style="text-align:center">Vehicle Sound Simulation</div>`,
  title: "Blocked Impedance",
  layout: {
    type: "customCase040203",
    options: {
      simulationIframeSrc: `${config.IFRAMES_REACT_URL}/case-0402-02/`,
    },
  },
};

export default principle;
